module.exports = __webpack_public_path__ + "img/wss-img.52210ea8.png";